const ViewType = [
  { id: 'AP4', name: 'AP4' },
  { id: 'AP2', name: 'AP2' },
  { id: 'AP3', name: 'AP3' },
  { id: 'LAX', name: 'LAX' },
  { id: 'SAX', name: 'SAX' },
  { id: 'pSAX-ap1', name: 'pSAX-ap1' },
];

const StageName = [
  { id: 'NORMAL', name: 'Normal' },
  { id: 'STRESS', name: 'Stress' },
  { id: 'QUAD', name: 'Quad View' },
];

const quadViewPairs = [
  ['AP4', 'AP2'],
  ['LAX', 'SAX'],
  ['AP3', 'pSAX-ap1'],
];

export { ViewType, StageName, quadViewPairs };
